import moment from "moment-timezone";
import request from "@/api/request";
import {ListTypeEnum} from '@/enums/list-type.enum';
import {OrderDirectionEnum} from '@/enums/order-direction.enum';

export const getListCalendars = (orgId, filterValue = '', currentPage = 0, pageSize = 100) => {
    return request({
        url: `/list`,
        method: 'post',
        data: {
            parentOrgId: orgId,
            type: ListTypeEnum.PARTICIPANT_ROTATIONAL,
            pageSize,
            currentPage,
            filterValue,
            recursive: true,
            sortField: 'name',
            sortOrder: OrderDirectionEnum.ASC,
        }
    })
}

export const getCalendarById = calendarId => {
    if (calendarId) {
        return request({
            url: `/participant-rotationals/${calendarId}`,
            method: 'get',
        })
    }
}

export const getListEvents = (calendarId) => {
    return request({
        url: `/participant-rotationals/${calendarId}`,
        method: 'get',
    })
}

export const getListParticipants = (orgId, filterValue = undefined, currentPage = 0, pageSize = 2000) => {
    return request({
        url: `/list`,
        method: 'post',
        data: {
            parentOrgId: orgId,
            type: ListTypeEnum.PARTICIPANT_GROUP,
            pageSize,
            currentPage,
            filterValue,
            recursive: true,
            sortField: 'name',
            sortOrder: OrderDirectionEnum.ASC,
        }
    })
}

export const createCalendar = (calendar, weekGroups = []) => {
    return request({
        url: `/participant-rotationals`,
        method: 'post',
        data: {
            ...calendar,
            participantWeekGroups: weekGroups.map(g => ({
                ...g,
                participantRotationEvents: g.participantRotationEvents.map(e => ({
                    ...e,
                    dateRule: {
                        ...e.dateRule,
                        start: moment(e.dateRule.start, 'HH:mm').format('HH:mm:ss'),
                        end: moment(e.dateRule.end + ':59', 'HH:mm:ss').format('HH:mm:ss'),
                    }
                }))
            })),
        },
    })
}

export const cloneCalendar = (calendar, weekGroups = []) => {
    return request({
        url: `/participant-rotationals/clone`,
        method: 'post',
        data: {
            ...calendar,
            participantWeekGroups: weekGroups.map(g => ({
                ...g,
                participantRotationEvents: g.participantRotationEvents.map(e => ({
                    ...e,
                    dateRule: {
                        ...e.dateRule,
                        start: moment(e.dateRule.start, 'HH:mm').format('HH:mm:ss'),
                        end: moment(e.dateRule.end + ':59', 'HH:mm:ss').format('HH:mm:ss'),
                    }
                }))
            })),
        },
    })
}

export const updateCalendar = (calendar, weekGroups = []) => {
    return request({
        url: `/participant-rotationals`,
        method: 'put',
        data: {
            ...calendar,
            participantWeekGroups: weekGroups.map(g => ({
                ...g,
                participantRotationEvents: g.participantRotationEvents.map(e => ({
                    ...e,
                    dateRule: {
                        ...e.dateRule,
                        start: moment(e.dateRule.start, 'HH:mm').format('HH:mm:ss'),
                        end: moment(e.dateRule.end + ':59', 'HH:mm:ss').format('HH:mm:ss'),
                    }
                }))
            })),
        },
    })
}

export const removeCalendar = (calendarId) => {
    return request({
        url: `/participant-rotationals/${calendarId}`,
        method: 'delete',
    })
}

export const getCalendarAssignment = (calendarId, page = 0, pageSize = 20) => {
    return request({
        url: `/list/membership`,
        method: 'POST',
        data: {
            "currentPage": page,
            "objectId": calendarId,
            "pageSize": pageSize,
            "referenceType": "PARTICIPANT",
            "type": "PARTICIPANT_ROTATIONAL"
        },
    })
}
